var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPelota({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2C59D",
    d: "M6.394 6.26l.028-.052c.435-.827.626-2.018 2.12-3.23 1.567-1.204 3.761-1.368 4.915-.376 1.154.992.83 2.765-.737 3.97-1.3 1-3.658 1.237-4.263 1.463-1.496.567-3.56 1.987-6.192 4.259-.584.436-1.911-.749-1.479-1.271l.174-.117.169-.114C3.856 8.94 5.612 7.429 6.394 6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3E2C1",
    d: "M3.086 9.395l1.955.66c-.003.047-.336.323-.457.342L2.65 9.72c.106-.12.244-.23.435-.325zm-1.276.925l2.004.683c-.003.047-.332.299-.435.353l-2.016-.718.046-.042a1.89 1.89 0 0 1 .401-.276zm-1.109.914l1.978.71c-.003.046-.267.272-.377.32l-1.451-.579c-.025-.02-.215-.265-.15-.451z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B59375",
    d: "M8.98 8.523c3.296-.355 6.007-1.893 5.446-4.124-.05 2.825-3.61 3.594-5.526 3.845-2.057.59-5.429 3.481-6.405 4.276l-.083.067c-.498.419-1.6-.33-1.856-.84-.057.548 1.203 1.641 1.944 1.145l.062-.043.066-.046c1.128-.8 4.332-3.492 6.352-4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3E2C1",
    d: "M2.507 12.504c.12-.125.246-.216.371-.302l.1.345a.787.787 0 0 1-.38.276l-.091-.319zm1.139-.93c.12-.125.252-.214.378-.3l.112.387a.81.81 0 0 1-.378.287l-.112-.374zm1.189-.929c.12-.125.305-.235.402-.301l.116.4a.904.904 0 0 1-.404.299l-.114-.398zM2.217 13.01c.007-.074-.046-.162-.086-.304-.041-.141-.937-.004-1.575-.959-.213.062.222.707.642 1.025.42.319.806.298 1.02.237z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPelota);
export default __webpack_public_path__ + "static/media/pelota.180e20361be535f01deeed9d711e7055.svg";
export { ForwardRef as ReactComponent };